import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import { images } from '../../components/shared/assets';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import { useOverlayManager } from '../../contexts/OverlayContext';
import './GalleryMendoza.css';

// Mendoza-specific gallery images (using local assets)
const mendozaGalleryImages = [
  { src: '/assets/images/gallery-mendoza-landscape.png', alt: 'Mendoza Landscape' },
  { src: '/assets/images/destinationsMendoza.png', alt: 'Awasi Mendoza Lodge' },
  { src: '/assets/images/packageCollage1.png', alt: 'Vineyard Vista' },
  { src: '/assets/images/packageCollage2.png', alt: 'Wine Cellar' },
  { src: '/assets/images/packageCollage3.png', alt: 'Mountain View' },
  { src: '/assets/fullviewportmendoza.jpg', alt: 'Awasi Mendoza Villa' },
  { src: '/assets/mendoza-factsheet-hero.jpg', alt: 'Lodge Reflection' },
  { src: '/assets/experiencepagebreak.jpg', alt: 'Mendoza Experience' },
  { src: '/assets/images/video1.png', alt: 'Wine Tasting' },
  { src: '/assets/images/video2.png', alt: 'Vineyard Tour' },
  { src: '/assets/images/video3.png', alt: 'Mountain Expedition' },
  { src: '/assets/images/video4.png', alt: 'Harvest Experience' }
];

const GalleryMendoza: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);

  // Initialize features and clear hover state
  useEffect(() => {
    window.scrollTo(0, 0);
    const cleanup = initializeAllFeatures();
    setHoveredDestination(null);
    return cleanup;
  }, [setHoveredDestination]);

  return (
    <div className="gallery-mendoza-page">
      {/* Navigation with light variant for Mendoza */}
      <SmartNavigation forceVariant="light" />

      {/* Hero Section */}
      <div 
        className="gallery-hero-section"
        data-scroll-section="hero"
        style={{ 
          backgroundImage: `url('/assets/mendoza-factsheet-hero.jpg')`
        }}
      >
        <div className="gallery-hero-overlay">
          <h1 className="gallery-hero-title">Awaken to Unforgettable Views</h1>
          <p className="gallery-hero-subtitle">Take a seat in the front row, watching the theatre of mother nature unfold.</p>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="gallery-filter-bar" data-scroll-section="filters">
        <div className="gallery-filters">
          <button 
            className={`filter-button ${selectedFilter === 'mendoza' ? 'active' : ''}`}
            onClick={() => setSelectedFilter(selectedFilter === 'mendoza' ? null : 'mendoza')}
          >
            MENDOZA +
          </button>
          <button 
            className={`filter-button ${selectedFilter === 'type' ? 'active' : ''}`}
            onClick={() => setSelectedFilter(selectedFilter === 'type' ? null : 'type')}
          >
            TYPE +
          </button>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="gallery-grid-section" data-scroll-section="gallery-grid">
        <div className="gallery-grid">
          {mendozaGalleryImages.map((image, index) => (
            <div 
              key={index} 
              className={`gallery-item gallery-item--${(index % 4) + 1}`}
              data-scroll-animation="fade-up"
            >
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>

      {/* Instagram Section */}
      <div data-scroll-section="instagram">
        <InstagramSection 
          title="Follow us on Instagram @awasiexperience"
          posts={[
            { src: images.instagram1, alt: "Mendoza Instagram 1" },
            { src: images.instagram2, alt: "Mendoza Instagram 2", isVideo: true },
            { src: images.instagram3, alt: "Mendoza Instagram 3" },
            { src: images.instagram4, alt: "Mendoza Instagram 4" }
          ]}
        />
      </div>

      {/* Footer with Mendoza variant */}
      <Footer variant="mendoza" />
    </div>
  );
};

export default GalleryMendoza;